<div class="d-flex align-items-center justify-content-center vh-100 overflow-auto flex-wrap">
    <!-- Page Wrapper -->
    <div class="content">
        <div class="container">
            <div class="error-main-logo text-center">
                <img src="assets/img/logo-dark.svg" alt="Img">
            </div>
            <div class="error-img text-center">
                <img src="assets/img/error-400.svg" alt="Img">
            </div>
            <div class="maintenance-update">
                <div class="text-center mb-3">
                    <h5 class="mb-1">404 Oops! Page Not Found</h5>
                    <p class="text-gray-6">This page doesn't exist or was removed! We suggest you back to home.</p>

                </div>
                <div class="d-flex align-items-center justify-content-center">
                    <a [routerLink]="routes.index" class="btn btn-primary d-flex align-items-center justify-content-center"><i class="isax isax-arrow-left-2 me-2"></i>Back to Home</a>
                </div>
            </div>
        </div>
    </div>
    <!-- Page Wrapper -->

</div>